import { Component, type OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  BaseMatcherEditorComponent,
  type MatcherComponentRegistryService,
} from '@cdw-ae/filter-bar-core';
import type {
  FieldMatcher,
  OneOfFilterOptions,
} from '@cdw-ae/filter-bar-interfaces';
import { map } from 'rxjs';

export const OneOfMatcher: FieldMatcher = {
  name: 'oneOf',
  displayName: 'One of',
  hasEditor: true,
  options: {
    chipFormatter: (value: string) => `: ${value}`,
  },
  editorOptions: {
    selectionOptions: [],
  },
};

@Component({
  selector: 'cdw-one-of-matcher',
  template: `
    <div *ngIf="matcherOptions; else noOptions" [formGroup]="state">
      <mat-radio-group
        formControlName="selectedOption"
        class="flex flex-col items-start mx-0 my-15 max-h-300"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
      >
        <mat-radio-button class="m-1" *ngFor="let option of listOptions" [value]="option.name">
          {{ option.displayName }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-template #noOptions><p>No options provided</p></ng-template>
  `,
  styles: [
    `
      mat-radio-group {
        width: 100%;
      }
    `,
  ],
  standalone: false,
})
export class OneOfMatcherComponent
  extends BaseMatcherEditorComponent
  implements OnInit
{
  public listOptions!: {
    name: string;
    displayName: string;
    defaultSelected?: boolean;
  }[];

  public override state = new FormGroup({
    selectedOption: new FormControl<string>(''),
  });

  constructor() {
    super();
    this.matcherDisplayName = OneOfMatcher.displayName;
    this.matcherName = OneOfMatcher.name;
    this.hasErrors$ = this.state.controls.selectedOption.valueChanges.pipe(
      map(() => this.state.controls.selectedOption.invalid)
    );
    this.state.controls.selectedOption.valueChanges.subscribe(
      (value: string | null) => {
        this.valueToMatch = value;
      }
    );
  }

  ngOnInit(): void {
    const options: OneOfFilterOptions = this.matcherOptions?.selectedMatcher
      ?.editorOptions as OneOfFilterOptions;
    if (options) {
      this.listOptions = options.selectionOptions;
    }
    this.state.controls.selectedOption.setValidators(Validators.required);
    this.state.controls.selectedOption.setValue(
      (this.matcherOptions.matchValue as string) ?? ''
    );
  }

  /**
   * Register this component with the matcher registry
   */
  public static registerOneOf(registry: MatcherComponentRegistryService): void {
    registry.registerComponent('oneOf', OneOfMatcherComponent);
  }
}
